import { useEffect, useState, useMemo } from "react";
import React from "react";
import "../../../../styles/deviceStyle.css";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button } from "@vds/buttons";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import { Checkbox } from "@vds/checkboxes";
import {
  createAlertGroup,
  editAlertGroupRequest,
  setActionType,
  setAlertGroupDetail,
  setAlertUserDetail,
  setCurrentModal,
  setNotification,
  setIsLoading,
  fetchRequest,
} from "../../../../store/actions/alertsGroup";
import { fetchUser, fetchUserSuccess } from "../../../../store/actions/user";
import { DropdownFilterWithSearchAndCheckbox } from "../../../../components/DropdownFilter";
import DropdownFilterWithSearchAndCheckboxWithoutSort from "../../../../components/DropdownFilters/DropdownFilterWithSearchAndCheckboxWithoutsort";

const CustomUserList = ({
  alertsGroupDetail,
  children,
  footerButtons,
  buttonName,
}) => {
  const user = useSelector((state) => state.auth.user);
  const currentModal = useSelector((state) => state.alertsGroup.currentModal);
  const [tableLoading, setTableLoading] = useState(false);
  const [column, setColumn] = useState([]);
  const [buttonNameProp, setButtonName] = useState(buttonName);
  const dispatch = useDispatch();
  const actionType = useSelector((state) => state.alertsGroup.actionType);
  let userList = useSelector((state) => state.user.users);
  const isLoading = useSelector((state) => state.alertsGroup.isLoading);
  const onSelectChange = (newSelectedRowKeys) => {
    dispatch(setAlertGroupDetail({ userList: newSelectedRowKeys }));
  };

  const selectedUser = useSelector(
    (state) => state.alertsGroup.alertGroupDetail.userList
  );
  const filters = useSelector((state) => state.alertsGroup.filters);
  const alertGroupDetails = useSelector(
    (state) => state.alertsGroup.alertGroupDetail
  );
  const alertUserDetail = useSelector(
    (state) => state.alertsGroup.alertUserDetail
  );
  const acccountName = sessionStorage.getItem("accountId");

  const handleNext = () => {
    dispatch(setAlertUserDetail({ searchName: [], asc: true }));
    if (currentModal == "ReviewAlertGroupDetailModal") {
      if (actionType == "Edit") {
        dispatch(
          editAlertGroupRequest({
            id: alertGroupDetails.id,
            alertGroupName: alertGroupDetails.alertGroupName,
            description: alertGroupDetails.description,
            users: alertGroupDetails.userList,
          })
        );
        dispatch(setNotification(null));
        dispatch(setCurrentModal(""));
      } else {
        dispatch(
          createAlertGroup({
            alertGroupName: alertGroupDetails.alertGroupName,
            description: alertGroupDetails.description,
            users: alertGroupDetails.userList,
          })
        );
        dispatch(setNotification(null));
        dispatch(setCurrentModal(""));
      }
      setTimeout(() => {
        dispatch(fetchRequest({ ...filters }));
      }, 2000);
    } else if (currentModal == "ViewAlertGroupModal") {
      dispatch(setActionType("Edit"));
      dispatch(setCurrentModal("AlertGroupDetailModal"));
    } else {
      if (selectedUser?.length >= 1)
        dispatch(setCurrentModal("ReviewAlertGroupDetailModal"));
    }
  };

  const handleBack = () => {
    dispatch(setAlertUserDetail({ searchName: [], asc: true }));
    if (currentModal == "ReviewAlertGroupDetailModal") {
      dispatch(setCurrentModal("EditUserListModal"));
    } else {
      dispatch(setCurrentModal(""));
    }
  };
  useEffect(() => {
    applyFilters();
  }, [alertUserDetail?.searchName, userList]);
  const applyFilters = () => {
    const filtered = userList?.filter((item) => {
      const isUserNameMatch =
        !alertUserDetail?.searchName ||
        alertUserDetail?.searchName === "Select All" ||
        (Array.isArray(alertUserDetail?.searchName) &&
          alertUserDetail?.searchName?.length === 0) ||
        (Array.isArray(alertUserDetail?.searchName) &&
          alertUserDetail?.searchName.some((name) => `${item?.name}` === name));
      return isUserNameMatch;
    });
    dispatch(setAlertUserDetail({ filteredData: filtered }));
  };
  const handleNameFilter = (val) => {
    dispatch(
      setAlertUserDetail({ searchName: val.filteredResult, asc: val.isAsc })
    );
  };
  const handleNameResetFilter = (val) => {
    dispatch(setAlertUserDetail({ searchName: [], asc: true }));
  };
  const Names = useMemo(() => {
    const uniqueNames = [];
    userList?.forEach((val) => {
      if (!uniqueNames.some((name) => name.text === `${val?.name}`)) {
        uniqueNames.push({ text: `${val?.name}`, value: false });
      }
    });
    return uniqueNames;
  }, [userList]);

  // if(currentModal==='ReviewAlertGroupDetailModal'){
  //   userList = userList?.filter(user=>selectedUser?.includes(user.key));
  // }
  // const rowSelection = currentModal=='EditUserListModal' ? {
  //   selectedRowKeys: selectedUser,
  //   onChange: onSelectChange,
  // } : null;
  const rowSelection =
    currentModal === "EditUserListModal"
      ? {
          selectedRowKeys: selectedUser,
          onChange: onSelectChange,
          preserveSelectedRowKeys: true,
          getCheckboxProps: (record) => ({
            disabled: false,
            name: record?.name,
            id: `checkbox-${record.key}`,
          }),
          renderCell: (checked, record, index, originNode) => {
            return (
              <Checkbox
                selected={checked}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  const safeSelectedUser = selectedUser ?? [];
                  onSelectChange(
                    isChecked
                      ? [...safeSelectedUser, record.key]
                      : safeSelectedUser.filter((key) => key !== record.key),
                    isChecked ? [record] : []
                  );
                }}
                name={record?.name}
                id={`checkbox-${record.key}`}
              />
            );
          },
        columnTitle: (
          <Checkbox
            selected={
              (selectedUser ?? []).length ===
              ((alertUserDetail?.filteredData ?? userList ?? []).length)
            }
            onChange={(e) => {
              const isChecked = e.target.checked;
              const data = alertUserDetail?.filteredData ?? userList ?? [];
              const allKeys = data.map((item) => item.key);
              onSelectChange(
                isChecked ? allKeys : [],
                isChecked ? data : []
              );
            }}
            id="select-all-checkbox"
          />
        ),
      }
      : null;

  const btnName = () => {
    if (currentModal == "ReviewAlertGroupDetailModal") {
      if (actionType == "Edit") {
        return "Save";
      } else {
        return "Add";
      }
    } else if (currentModal == "ViewAlertGroupModal") {
      return "Edit";
    }
    return "Next";
  };
  useEffect(() => {
    dispatch(setIsLoading(true));
    if (currentModal == "ViewAlertGroupModal") {
      dispatch(
        fetchUserSuccess(
          alertsGroupDetail?.users?.map((user) => ({
            key: user?.id,
            name: `${user?.firstname} ${user?.lastname}`,
            email: user?.email,
            role: user?.role || "ORG_ADMIN",
            id: user?.credentialsid,
            phoneNumber: user?.mdn,
          }))
        )
      );
      dispatch(
        setAlertGroupDetail({
          userList: alertsGroupDetail?.users?.map((user) => user?.id),
        })
      );
      dispatch(setIsLoading(false));
    } else {
      dispatch(fetchUser());
    }
  }, [alertsGroupDetail, acccountName]);

  useEffect(() => {
    setTableLoading(true);
    const column = [
      {
        title:
          currentModal === "ViewAlertGroupModal" || currentModal === "ReviewAlertGroupDetailModal"
            ? "Name"
            : (
              <DropdownFilterWithSearchAndCheckboxWithoutSort
                text="Name"
                isSearchable={true}
                onApply={handleNameFilter}
                onReset={handleNameResetFilter}
                checkboxItems={Names?.map((name) => ({
                  text: name?.text,
                  value: alertUserDetail?.searchName?.includes(name.text),
                }))}
              />
            ),
        dataIndex: "name",
        key: "name",
        width: "30%",
      },
      { title: "Email", dataIndex: "email", key: "email", width: "40%" },
    ]; //{ title: "Role", dataIndex: "role", key: "role" }]
    if (currentModal != "ViewAlertsGroupModal") {
      column.splice(2, 0, {
        title: "Phone",
        dataIndex: "phoneNumber",
        key: "phoneNumber",
      });
    }
    setColumn(column);
    return () => {
      dispatch(setIsLoading(false));
    };
  }, [userList?.length, currentModal]);

  alertUserDetail?.filteredData?.sort((a, b) => {
    let valA = a[alertUserDetail?.sortColumn];
    let valB = b[alertUserDetail?.sortColumn];
    if (typeof valA === "string" && typeof valB === "string") {
      return alertUserDetail?.asc
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    } else if (typeof valA === "number" && typeof valB === "number") {
      return alertUserDetail?.asc ? valA - valB : valB - valA;
    }
    return 0;
  });
  return (
    <div style={{ minHeight: "auto", margin: "0 auto", marginTop: 0 }}>
      <span>
        {selectedUser?.length >= 1
          ? ""
          : "Please select at least one user to proceed."}
      </span>
      {children}
      <Table
        rowKey="key"
        loading={isLoading}
        columns={column}
        dataSource={
          currentModal === "ReviewAlertGroupDetailModal"
            ? userList?.filter((user) => selectedUser?.includes(user.key))
            : alertUserDetail?.filteredData || userList
        }
        // dataSource={userList}
        // dataSource={alertUserDetail?.filteredData}
        rowSelection={rowSelection}
        // onChange={handleTableChange}
        style={{
          width: "100%",
          minWidth: "1200px",
          overflowX: "auto",
        }}
      />
      {footerButtons ? (
        <Grid2
          container
          marginTop={1}
          marginBottom={0}
          spacing={1}
          columns={{ xs: 12 }}
        >
          <Grid2 item xs={12} sm={6} md={6} lg={6}>
            <div className="mb-3">
              <Button
                className="custom-button-cancel"
                type="default"
                shape="round"
                style={{
                  fontWeight: "bold",
                  width: "100%",
                  backgroundColor: "white",
                  color: "black",
                }}
                onClick={() => handleBack()}
                size={"large"}
              >
                {currentModal == "ReviewAlertGroupDetailModal"
                  ? "Back"
                  : "Cancel"}
              </Button>
            </div>
          </Grid2>
          <Grid2 item xs={12} sm={6} md={6} lg={6}>
            <div className="mb-3">
              <Button
                className="custom-button-cancel"
                type="default"
                shape="round"
                disabled={ isLoading || selectedUser?.length === 0 }
                onClick={() => handleNext()}
                style={{ fontWeight: "bold", width: "100%" }}
                size={"large"}
              >
                {btnName()}
              </Button>
            </div>
          </Grid2>
        </Grid2>
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomUserList;
